export default __webpack_public_path__ + "static/media/Selected-09.ef699085.svg";